import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const SKELETON_COLORS = {
  bone: PRIMITIVE_COLORS.white,
  darkBone: PRIMITIVE_COLORS.lightYellow,
  border: PRIMITIVE_COLORS.darkSlate,
  eye: PRIMITIVE_COLORS.red,
  shadow: PRIMITIVE_COLORS.darkSlate,
};

export const SKELETON_BLUEPRINT: PrimitiveBlueprint = {
  id: "skeleton",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.1, y: 0.82, w: 0.8, h: 0.16 },
      style: { fill: SKELETON_COLORS.shadow, fillAlpha: 0.35 },
      z: 0,
    },
    {
      id: "skull",
      type: "roundRect",
      bounds: { x: 0.2, y: 0.1, w: 0.6, h: 0.35 },
      style: {
        fill: SKELETON_COLORS.bone,
        stroke: SKELETON_COLORS.border,
        strokeWidth: 3,
      },
      z: 1,
    },
    {
      id: "eye-left",
      type: "ellipse",
      bounds: { x: 0.32, y: 0.22, w: 0.12, h: 0.12 },
      style: { fill: SKELETON_COLORS.eye },
      z: 2,
    },
    {
      id: "eye-right",
      type: "ellipse",
      bounds: { x: 0.56, y: 0.22, w: 0.12, h: 0.12 },
      style: { fill: SKELETON_COLORS.eye },
      z: 2,
    },
    {
      id: "spine",
      type: "rect",
      bounds: { x: 0.42, y: 0.45, w: 0.16, h: 0.25 },
      style: {
        fill: SKELETON_COLORS.bone,
        stroke: SKELETON_COLORS.border,
        strokeWidth: 2,
      },
      z: 1,
    },
    {
      id: "rib-left-1",
      type: "line",
      bounds: { x: 0.3, y: 0.5, w: 0.12, h: 0 },
      style: { stroke: SKELETON_COLORS.border, strokeWidth: 2 },
      z: 2,
    },
    {
      id: "rib-left-2",
      type: "line",
      bounds: { x: 0.3, y: 0.58, w: 0.12, h: 0 },
      style: { stroke: SKELETON_COLORS.border, strokeWidth: 2 },
      z: 2,
    },
    {
      id: "rib-right-1",
      type: "line",
      bounds: { x: 0.58, y: 0.5, w: 0.12, h: 0 },
      style: { stroke: SKELETON_COLORS.border, strokeWidth: 2 },
      z: 2,
    },
    {
      id: "rib-right-2",
      type: "line",
      bounds: { x: 0.58, y: 0.58, w: 0.12, h: 0 },
      style: { stroke: SKELETON_COLORS.border, strokeWidth: 2 },
      z: 2,
    },
    {
      id: "pelvis",
      type: "roundRect",
      bounds: { x: 0.35, y: 0.7, w: 0.3, h: 0.1 },
      style: {
        fill: SKELETON_COLORS.bone,
        stroke: SKELETON_COLORS.border,
        strokeWidth: 2,
      },
      z: 1,
    },
  ],
};
